export const widgetButton = {
  code: "widget-button",
  type: "html",
  label: "按钮",
  icon: "icon-icon-anniu",
  options: {
    // 配置
    setup: [
      {
        type: "el-input-number",
        label: "字体大小",
        name: "fontSize",
        required: false,
        placeholder: "",
        value: "14",
      },
      {
        type: "vue-color",
        label: "字体颜色",
        name: "color",
        required: false,
        placeholder: "",
        value: "#FFFFFF",
      },
      {
        type: "vue-color",
        label: "背景色",
        name: "background",
        required: false,
        placeholder: "",
        value: "#22AC35",
      },
      // {
      //   type: "el-select",
      //   label: "文字粗细",
      //   name: "fontWeight",
      //   required: false,
      //   placeholder: "",
      //   selectOptions: [
      //     { code: "normal", name: "正常" },
      //     { code: "bold", name: "粗体" },
      //     { code: "bolder", name: "特粗体" },
      //     { code: "lighter", name: "细体" },
      //   ],
      //   value: "normal",
      // },
      // {
      //   type: "el-select",
      //   label: "对齐方式",
      //   name: "textAlign",
      //   required: false,
      //   placeholder: "",
      //   selectOptions: [
      //     { code: "center", name: "居中" },
      //     { code: "left", name: "左对齐" },
      //     { code: "right", name: "右对齐" },
      //   ],
      //   value: "left",
      // },
    ],
    // 数据
    data: [],
    // 坐标
    position: [
      {
        type: "el-input-number",
        label: "左边距",
        name: "left",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "上边距",
        name: "top",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "宽度",
        name: "width",
        required: false,
        placeholder: "该容器在1920px大屏中的宽度",
        value: 100,
      },
      {
        type: "el-input-number",
        label: "高度",
        name: "height",
        required: false,
        placeholder: "该容器在1080px大屏中的高度",
        value: 32,
      },
    ],
  },
};
